import useUpdateSubitemField from "api/api-hooks/subitems/useUpdateSubitemField";
import FiltersButtonWithOptions from "components/SavedFilters/FiltersButtonWithOptions";
import StrUtils from "utils/StrUtils";

const SubitemFiltersButton = ({
  module,
  fieldSchema,
  query,
  setQuery,
  parentRecord,
}) => {
  const { updateSubitemField, updatingSubitem } = useUpdateSubitemField();
  let currentFilters =
    fieldSchema?.SavedFilters?.length > 0 ? fieldSchema?.SavedFilters : [];

  return (
    <FiltersButtonWithOptions
      currentModule={module}
      stateQuery={fieldSchema?.Query?.[0]?.Query}
      filters={fieldSchema?.SavedFilters}
      query={query?.[0]?.Query}
      setQuery={setQuery}
      onSave={updateDefaultFilters}
      submitting={updatingSubitem}
      clearFilter={clearFilter}
      createFilter={createItem}
      updateFilter={updateItem}
      deleteFilter={deleteItem}
      reorderFilters={reorderItems}
      title="Subitem Filters"
      updateKey="SavedFilters"
      createKey="SavedFilter"
      emptyDescription="No subitem filters available. Get started by adding a new one."
      subitemFieldsOnly={fieldSchema?.APIName}
      checkForFields={false}
      subitemQuery={true}
    />
  );

  function updateDefaultFilters(filters, type) {
    query[0].Query.Filters = filters?.length ? filters : [];

    query.Metadata = { Default: true };
    type && (query.Metadata.Type = type);

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema?.APIName,
      payload: {
        Query: query,
      },
      onSuccess: () => setQuery(query),
    });
  }

  function clearFilter() {
    setQuery([
      {
        QueryField: query[0].QueryField,
        Query: { ...query[0].Query, Filters: [] },
      },
    ]);
  }

  function createItem(filter) {
    let newFilter = filter.payload;
    newFilter.id = StrUtils.uuidv4();
    currentFilters.push(newFilter);

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        SavedFilters: currentFilters,
      },
      onSuccess: () => setQuery(query),
    });

    filter.onSuccess();
  }

  function updateItem(filter) {
    let updatedFilter = filter.payload;
    updatedFilter.id = filter.id;

    const updatedFilters = currentFilters.map((item) =>
      item.id === updatedFilter.id ? updatedFilter : item
    );

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        SavedFilters: updatedFilters,
      },
      onSuccess: () => setQuery(query),
    });

    filter.onSuccess();
  }

  function deleteItem(filter) {
    const updatedFilters = currentFilters.filter(
      (item) => item.id !== filter.id
    );

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        SavedFilters: updatedFilters,
      },
      onSuccess: () => setQuery(query),
    });
  }

  function reorderItems(reorderItems) {
    let newOrderedIds = reorderItems.newOrder;
    currentFilters.sort((a, b) => {
      const aIndex = newOrderedIds.indexOf(a.id);
      const bIndex = newOrderedIds.indexOf(b.id);
      return aIndex - bIndex;
    });

    updateSubitemField({
      moduleAPIName: parentRecord?._ModuleAPIName,
      fieldAPIName: fieldSchema.APIName,
      payload: {
        SavedFilters: currentFilters,
      },
      onSuccess: () => setQuery(query),
    });
  }
};

export default SubitemFiltersButton;
